import request from '@/_helpers/requests/requestNotif'

export const configService = {
    initConfiguration() {
        return new Promise((resolve, reject) => {

            request.get('initParams').then(response => {
                
                    resolve(response.data)
                
            }, error => {
                reject(error);
            });
        });
    },

    adminPageParams() {
        return new Promise((resolve, reject) => {

            request.get('admin/pageParams').then(response => {
                resolve(response.data)
            }, error => {
                reject(error);
            });
        });
    },
};